import { db } from '../../common/config/Firebase';

/**
 * Fetches all employees from Firestore
 * @returns {Promise<Array>} - Array of employee objects
 */
export const getAllEmployeesUseCase = async () => {
    try {
        const snapshot = await db.collection('employees').get();

        const employees = [];
        snapshot.forEach(doc => {
            employees.push({
                dni: doc.id,
                ...doc.data()
            });
        });

        console.log(`Fetched ${employees.length} employees`);
        return employees;
    } catch (error) {
        console.error('Error fetching employees:', error);
        throw error;
    }
};
